export default __webpack_public_path__ + "static/media/pc-banner.50750c02.png";